/* global $, jQuery, Fancybox */

/**
 * Gallery thumbnail interaction and Fancybox initialization
 * for stone detail pages.
 */
export function initGallery() {
  // Thumbnail click switches main image
  $('.gallery__thumb').on('click', function () {
    var $thumb = $(this);

    // Update active state
    $('.gallery__thumb').removeClass('gallery__thumb--active');
    $thumb.addClass('gallery__thumb--active');

    // Get detail image paths from data attributes
    var detailJpg = $thumb.data('src');
    var detailWebp = $thumb.data('srcset');

    if (detailJpg) {
      // Update <picture>: <source srcset> and <img src>
      var $main = $('.gallery__main');
      $main.find('picture source').attr('srcset', detailWebp);
      $main.find('picture img').attr('src', detailJpg);
      // Update Fancybox link
      $main.find('a[data-fancybox]').attr('href', detailWebp);
    }
  });

  // Initialize Fancybox lightbox
  if (typeof Fancybox !== 'undefined') {
    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: { type: 'classic' },
      Toolbar: {
        display: {
          left: [],
          middle: ['prev', 'infobar', 'next'],
          right: ['close']
        }
      }
    });
  }
}
